import Field from './component';
import { FieldProps } from './types';

export default Field;
export type { FieldProps };
